// src/components/EditAccountModal.js
import React, { useState, useEffect } from 'react';
import { ModalContainer, ModalContent, Form, Label, Select, Button, Input } from './StyledComponents';
import AssetAvailabilityFields from './AssetAvailabilityFields';

const EditAccountModal = ({ account, isOpen, onClose, onSave }) => {
  const [name, setName] = useState('');
  const [balance, setBalance] = useState(0);
  const [type, setType] = useState('Bank');
  const [color, setColor] = useState('#000000');
  const [availabilityType, setAvailabilityType] = useState('now');
  const [availableFromAge, setAvailableFromAge] = useState(60);
  const [availableFromDate, setAvailableFromDate] = useState('');

  useEffect(() => {
    if (account) {
      setName(account.name);
      setBalance(account.balance);
      setType(account.type);
      setColor(account.color || '#000000');
      setAvailabilityType(
        account.availabilityType === 'age' || account.availabilityType === 'date'
          ? account.availabilityType
          : 'now'
      );
      setAvailableFromAge(account.availableFromAge ?? 60);
      setAvailableFromDate(account.availableFromDate || '');
    }
  }, [account]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const availability = type === 'Asset'
      ? {
          availabilityType,
          availableFromAge:
            availabilityType === 'age' ? parseInt(availableFromAge, 10) : null,
          availableFromDate: availabilityType === 'date' ? availableFromDate : null,
        }
      : {
          availabilityType: 'now',
          availableFromAge: null,
          availableFromDate: null,
        };
    onSave({
      ...account,
      name,
      balance: parseFloat(balance),
      type,
      color,
      ...availability,
    });
  };

  if (!isOpen || !account) return null;

  return (
    <ModalContainer>
      <ModalContent>
        <Form onSubmit={handleSubmit}>
          <Label>Name:</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} />
          <Label>Balance:</Label>
          <Input type="number" step="0.01" value={balance} onChange={(e) => setBalance(e.target.value)} />
          <Label>Colour:</Label>
          <Input type="color" value={color} onChange={(e) => setColor(e.target.value)} />
          <Label>Type:</Label>
          <Select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="Bank">Bank</option>
            <option value="Loan">Loan</option>
            <option value="Asset">Asset</option>
            <option value="Income">Income</option>
            <option value="Expense">Expense</option>
          </Select>
          {type === 'Asset' && (
            <AssetAvailabilityFields
              availabilityType={availabilityType}
              availableFromAge={availableFromAge}
              availableFromDate={availableFromDate}
              onAvailabilityTypeChange={(e) => setAvailabilityType(e.target.value)}
              onAvailableFromAgeChange={(e) => setAvailableFromAge(e.target.value)}
              onAvailableFromDateChange={(e) => setAvailableFromDate(e.target.value)}
            />
          )}
          <Button type="submit">Save Changes</Button>
          <Button onClick={onClose}>Close</Button>
        </Form>
      </ModalContent>
    </ModalContainer>
  );
};

export default EditAccountModal;
